/* eslint-disable import/no-anonymous-default-export */
import cioffImage from "../../static/images/cioff.svg";
import argentinaImage from "../../static/images/argentina.svg";
import boliviaImage from "../../static/images/bolivia.svg";
import bulgariaImage from "../../static/images/bulgaria.svg";
import brasilImage from "../../static/images/brasil.svg";
import canadaImage from "../../static/images/canada.svg";
import chileImage from "../../static/images/chile.svg";
import colombiaImage from "../../static/images/colombia.svg";
import costaRicaImage from "../../static/images/costaRica.svg";
import cyprusImage from "../../static/images/cyprus.svg";
import estoniaImage from "../../static/images/estonia.svg";
import franceImage from "../../static/images/france.svg";
import germanyImage from "../../static/images/germany.svg";
import greeceImage from "../../static/images/greece.svg";
import hungaryImage from "../../static/images/hungary.svg";
import indonesiaImage from "../../static/images/indonesia.svg";
import israelImage from "../../static/images/israel.svg";
import italyImage from "../../static/images/italy.svg";
import kyrgyzstanImage from "../../static/images/kyrgyzstan.svg";
import luxembourgImage from "../../static/images/luxembourg.svg";
import mexicoImage from "../../static/images/mexico.svg";
import paraguayImage from "../../static/images/paraguay.svg";
import pakistanImage from "../../static/images/pakistan.svg";
import switzerlandImage from "../../static/images/switzerland.svg";
import salvadorImage from "../../static/images/salvador.svg";
import sloveniaImage from "../../static/images/slovenia.svg";
import turkeyImage from "../../static/images/turkey.svg";
import usaImage from "../../static/images/usa.svg";

const initialState = [
  {
    id: "cioff",
    nameEN: "CIOFF",
    nameFR: "CIOFF",
    nameES: "CIOFF",
    src: cioffImage,
    descriptionEN: `Since 1970, CIOFF® 
    has worked for the 
    safeguarding, promotion, and 
    diffusion of traditional culture. 
    Through its activities, CIOFF® 
    aims for the following main 
    objectives:
    Promote the intangible heritage, 
    through forms of expression such 
    as dance, music, games, rituals, 
    customs and other arts.
    Serve the objectives of UNESCO
    Support the activities of its 
    members and those of nongovernmental organizations 
    working in the areas of folklore and 
    cultural heritage
    Serve the cause of peace and nonviolence through the 
    implementation of the above 
    objectives
    It is estimated that over 1 million 
    people, including over 30,000 folklore 
    dance, musical groups, and folk arts 
    organizations are associated with 
    CIOFF® through their CIOFF® 
    National Sections Worldwide.`,
    descriptionFR: `Depuis 1970, le CIOFF®
    œuvre pour la sauvegarde,
    la promotion et la diffusion de la 
    culture traditionnelle. Par ses 
    activités, le CIOFF® vise les 
    principaux objectifs suivants:
    Promouvoir le patrimoine immatériel 
    à travers des formes d'expression 
    telles que la danse, la musique, les 
    jeux, les rituels, les coutumes et 
    autres arts.
    Servir les objectifs de l'UNESCO
    Soutenir les activités de ses 
    membres et celles des organisations 
    non gouvernementales travaillant 
    dans les domaines du folklore et du 
    patrimoine culturel
    Servir la cause de la paix et de la 
    non-violence par la mise en œuvre 
    des objectifs ci-dessus
    On estime que plus d'un million de 
    personnes, dont plus de 30 000 
    groupes folkloriques de danse et de 
    musique et des organisations d'arts 
    populaires, sont associées au 
    CIOFF® par le biais de leurs 
    sections nationales du CIOFF® dans 
    le monde entier.`,
    descriptionES: `Desde 1970, CIOFF®
    trabaja para salvaguardar, 
    promover y difundir la cultura 
    tradicional. A través de sus 
    actividades, CIOFF® apunta a los 
    siguientes objetivos principales:
    Promover el patrimonio inmaterial, a 
    través de formas de expresión como 
    la danza, la música, los juegos, los 
    rituales, las costumbres y otras artes.
    Servir a los objetivos de la UNESCO
    Apoyar las actividades de sus 
    miembros y las de las 
    organizaciones no gubernamentales 
    que trabajan en las áreas del folclore 
    y el patrimonio cultural
    Servir a la causa de la paz y la no 
    violencia a través de la 
    implementación de los objetivos 
    anteriores
    Se estima que más de 1 millón de 
    personas, incluidos más de 30 000 
    grupos de danza y música folclórica 
    y organizaciones de artes populares, 
    están asociados con CIOFF® a 
    través de sus Secciones Nacionales 
    CIOFF® en todo el mundo.`,
    fillColors: Array(52).fill("white"),
  },
  {
    id: "canada",
    nameEN: "Canada",
    nameFR: "Canada",
    nameES: "Canadá",
    src: canadaImage,
    descriptionEN: `Totem poles tell stories of the
    Aboriginal families of Canada. They
    are the records of important historical
    events, family and clan relationships,
    accomplishments, adventures and
    stories. Totem poles honor Aboriginal
    people through symbols. Such
    symbols include the eagle, raven,
    thunderbird, bear, beaver, wolf, killer
    whale and frog.`,
    descriptionFR: `Les totems racontent des histoires
    sur les familles autochtones du
    Canada. Ce sont les archives
    d'événements historiques importants,
    de relations familiales et claniques, de
    réalisations, d'aventures et d'histoires.
    Les mâts totémiques rendent
    hommage aux peuples autochtones
    grâce à des symboles. Un tel symbole
    comprend l'aigle, le corbeau, le
    Thunderbird, l'ours, le castor, le loup,
    l'orque et la grenouille.`,
    descriptionES: `Los tótems cuentan historias de
    las familias aborígenes de Canadá.
    Son los registros de eventos
    históricos importantes, relaciones
    familiares y de clanes, logros,
    aventuras e historias. Los tótems
    honran a los aborígenes a través de
    símbolos. Tales símbolos incluyen el
    águila, el cuervo, el ave del trueno, el
    oso, el castor, el lobo, la orca y la
    rana.`,
    fillColors: Array(98).fill("white"),
  },
  {
    id: "indonesia",
    nameEN: "Indonesia",
    nameFR: "Indonésie",
    nameES: "Indonesia",
    src: indonesiaImage,
    descriptionEN: `Barong is a Lion-like creature 
    and mythological creature of Bali 
    Island in Indonesia. He is the King 
    of the spirits, leader of the hosts of 
    good, and enemy of Rangda, the 
    demon queen and mother of all 
    spirit guarders.`,
    descriptionFR: `Barong est une créature 
    lionesque et caractère de la 
    mythologie de l'île de Bali en 
    Indonésie. Il est le roi des esprits, 
    leader des hôtes du bien et 
    ennemie de Rangda, la reine 
    démone et mère de tous les 
    esprits gardiens.`,
    descriptionES: `El Barong es una criatura 
    parecida al León, personaje 
    mitológico de la isla Bali en 
    Indonesia. Es el rey de los 
    espíritus, líder de los anfitriones 
    del bien, y enemigo de Rangda, la 
    reina demonio y madre de todos 
    los espíritus guardianes.`,
    fillColors: Array(111).fill("white"),
  },
  {
    id: "luxembourg",
    nameEN: "Luxembourg",
    nameFR: "Luxembourg",
    nameES: "Luxemburgo",
    src: luxembourgImage,
    descriptionEN: `The Luxemburg coat of arms 
    consists of 8 stripes, blue and 
    silver. The red lion inside İt is the 
    official coat of arms of the grandduchy of Luxembourg. The coat of 
    arms has the crown and the 
    escutcheon without external 
    ornaments.`,
    descriptionFR: `L'écusson luxembourgeois est 
    constitué de huit bandes bleu et 
    argnt avec un lion rouge au 
    centre. C'est l'écusson official du 
    grand duc de Luxembourg. 
    L'écusson comporte une couronne 
    et une plaque dans ornements 
    extérieurs.`,
    descriptionES: `El escudo de armas de 
    Luxemburgo consiste en 8 rayas 
    azules y plateadas con el león rojo 
    en su interior. Es el escudo oficial 
    de armas del Gran Ducado de 
    Luxemburgo. El escudo de armas 
    tiene la corona y el formato de 
    escudo sin adornos externos.`,
    fillColors: Array(980).fill("white"),
  },
  {
    id: "usa",
    nameEN: "U.S.A",
    nameFR: "U.S.A",
    nameES: "U.S.A",
    src: usaImage,
    descriptionEN: `Quilt-making has always been
    an essential part of American life 
    and culture. Quilts were traditionally
    made out of necessity but have now
    turned into an art form to share stories or 
    images. Quilting groups are now a norm for 
    many towns with quilts being passed down 
    from generation to generation.
    Quilts can also be interpreted as a 
    connection between several pieces of 
    different fabrics coming together to make 
    one beautiful cohesive item, just like culture 
    in the United States. We have cultures from 
    all over the world that come together to 
    build one United States of America.`,
    descriptionFR: `La fabrication de courtepointes a 
    toujours été une partie essentielle de la
    vie et de la culture américaines. Les 
    courtepointes ont été fabriquées à partir de 
    nécessités mais sont maintenant devenues 
    une forme d'art pour partager des histoires ou 
    des images. Les groupes de courtepointes 
    sont maintenant une norme pour de 
    nombreuses villes, les courtepointes étant 
    transmises de génération en génération.
    Les courtepointes peuvent également être 
    interprétées comme une connexion de plusieurs 
    morceaux de tissus différents qui se réunissent pour 
    former un objet conesive beuatful, tout comme la 
    culture aux États-Unis. Nous avons des cultures du 
    monde entier qui se réunissent pour construire les 
    États-Unis d'Amérique.`,
    descriptionES: `Hacer edredones siempre ha 
    sido una parte esencial de la vida 
    y la cultura estadounidense. Los 
    edredones se hicieron de forma 
    tradicional por necesidad, pero ahora se 
    han convertido en una forma de arte para 
    compartir historias o imágenes, de 
    generación en generación.
    Los edredones también se pueden 
    interpretar como una conexión de varias 
    piezas de tejidos diferentes que se unen 
    para formar un unico elemento atractivo, al 
    igual que la cultura en los Estados Unidos. 
    Tenemos culturas de todo el mundo que se 
    unen para construir un solo Estados Unidos.`,
    fillColors: Array(82).fill("white"),
  },
  {
    id: "brasil",
    nameEN: "Brasil",
    nameFR: "Brésil",
    nameES: "Brasil",
    src: brasilImage,
    descriptionEN: `The Indians were the first 
    inhabitants of Brazil and they 
    represent the origin of the Brazilian 
    people. Their cultures were full of 
    different habits, customs, beliefs, 
    and dialects prevail in our society 
    and is that cultural miscegenation 
    that constituted such a diversified 
    Brazil.`,
    descriptionFR: `Les aborigènes étaient les 
    premiers habitants du Brésil est ils 
    représentent l'origine du peuple 
    brésilien. Leur culture, remplie de 
    différentes habitudes, coutumes, 
    croyances et différents dialects, 
    persiste dans notre société et ce 
    métissage culturel constitue le 
    Brésil diversifié.`,
    descriptionES: `Los indígenas fueron los primers 
    habitantes de Brasil, representan 
    el origen de los brasileros. Sus 
    culturas llenas de distintos hábitos, 
    tradiciones, creencias y dialectos 
    prevalecen en nuestra socedad y 
    fue el mestizaje cultural el que 
    constituyó un Brasil tan diverso.`,
    fillColors: Array(55).fill("white"),
  },
  {
    id: "colombia",
    nameEN: "Colombia",
    nameFR: "Colombie",
    nameES: "Colombia",
    src: colombiaImage,
    descriptionEN: `Regions in Colombia are
    characterized by their cultural
    differences, footwear is one of them,
    which has been used in our folklore
    escenic projection. The calzado presented
    here is known as alpargata from central
    and east Andean zone (left), sandal from
    Caribbean zone (left-center), leather cotiza
    from llanero zone (right), tela cotiza or
    chocatos from general Andean zone and
    its valleys (right-center) and footprints
    (center) from those communities that walk
    on foot as their traditions reflex.`,
    descriptionFR: `Les diverses régions
    de la Colombie sont caractérisés
    par leurs différences culturelles. Les
    chaussures en font partie et sont utilisés
    dans les représentations de la culture
    folklorique. Le calzado présenté ici est
    connu comme: alparagata de la zone des
    Andes centre et est (gauche), la sandale
    de la zone des Caraïbes (gauche-centre),
    le cotiza en cuir de la zone Ilanero (droite),
    tela cotiza ou chocatos de la région des
    Andes en générale jusqu'à ses vallées
    (droite-centre) et les traces de pas pour
    les communautés qui marchent pied
    nus à titre de réflexe traditionnel.`,
    descriptionES: `En Colombia las
    regiones se caracterizan por
    tener calzados distintivos que se han
    utilizado en las proyecciones escénicas
    y que hacen parte de nuestro folclore.
    Alpargatas de la zona central y oriental
    andina (izquierda), sandalias de la zona
    caribe (izquierda centro), cotizas llaneras
    de la zona de los llanos orientales (derecha),
    cotizas de tela o chocatos de toda la
    zona andina y sus valles (derecha centro)
    y las huellas (centro) de aquellas comunidades
    que caminan con su pie descalzo cómo un
    reflejo de sus tradiciones, de nuestra historia.`,
    fillColors: Array(203).fill("white"),
  },
  {
    id: "estonia",
    nameEN: "Estonia",
    nameFR: "Estonie",
    nameES: "Estonia",
    src: estoniaImage,
    descriptionEN: `This Estonian traditional belt is part of 
    women’s traditional clothes. Estonian folk 
    costumes are divided into four main 
    regional groups: the folk costumes of 
    South- Estonia, North-Estonia, WestEstonia and the islands. The belts also 
    differ depending on the location of the 
    wearer. Because it was believed that the 
    belt will give girls strength and protects 
    them, it was very strongly tied around the 
    waist.`,
    descriptionFR: `La ceinture traditionnelle estonienne 
    fait partie des vêtements traditionnels 
    de la femme. Les costumes folkloriques 
    estoniens sont divisés en quatre grandes 
    régions principales: sud, nord, west et les 
    îles. Les ceintures sont différentes tout 
    dépendemment de l'emplacement du 
    porteur. Le peuple, croyant que la 
    ceinture procurait de la force aux filles et 
    les protégeait, l'attachait très serrée 
    autour de la taille.`,
    descriptionES: `El cinturón tradicional estonio es parte 
    de la vestimenta tradicional de las 
    mujeres. Los trajes típicos de Estonia se 
    dividen en cuatro grupos regionales 
    principales: los trajes típicos de Estonia 
    del Sur, Estonia del Norte, Estonia del 
    Oeste y las islas. Los cinturones también 
    difieren dependiendo de la localización 
    del usuario. Debido a que se creía que el 
    cinturón les daría fuerza a las chicas y las 
    protegería, estaba fuertemente atado 
    alrededor de la cintura. `,
    fillColors: Array(2605).fill("white"),
  },
  {
    id: "germany",
    nameEN: "Germany",
    nameFR: "Allemagne",
    nameES: "Alemania",
    src: germanyImage,
    descriptionEN: `The Sorbian bagpipe is played in the 
    region of Schleife together with the 
    small three-stringed violin. It consists 
    of a goatskin, a whistle, an on-board 
    whistle, and a bellows. The horns are 
    made of cow horns. The goat's head 
    made of wood is decorated with 
    canines of wild boar. The small threestringed Sorbian violin (małe husle, 
    huslički) is played in the region of the 
    village of Schleife.`,
    descriptionFR: `La cornemuse sorbe est jouée dans 
    la région du Schleife accompagné
    un petit violon à trois cordes. Elle est 
    faite de peau de chèvre, un sutell, un 
    embout et un soufflet. Les cornes sont 
    des cornes de vache. La tête de la 
    chèvre en bois est décorée des dents 
    d'un sanglier sauvage. Le petit violon 
    sorbe à trois cordes (husle male, 
    huslički) est joué dans la région du 
    village de Schleife.`,
    descriptionES: `La gaita Sorbian se toca en la 
    región de Schleife junto con el 
    pequeño violín de tres cuerdas. 
    Consiste en piel de cabra, un soplete, 
    un silbato marinero y un fuelle. Los 
    cuernos son cuernos de vaca. La 
    cabeza de la cabra hecha de madera 
    está decorada con caninos de jabalí. 
    El pequeño violín sorbio de tres 
    cuerdas (małe husle, huslički) se toca 
    en la región del pueblo de Schleife.`,
    fillColors: Array(153).fill("white"),
  },
  {
    id: "pakistan",
    nameEN: "Pakistan",
    nameFR: "Pakistan",
    nameES: "Pakistán",
    src: pakistanImage,
    descriptionEN: `Sitar is a stringed instrument of the 
    flute family that is popular in northern 
    India, Pakistan, and Bangladesh. 
    Typically measuring about 1.2 meters 
    (4 feet) in length, the sitar has a deep 
    pear-shaped gourd body; a long, wide, 
    hollow wooden neck; both front and 
    side tuning pegs; and 20 arched 
    movable frets.`,
    descriptionFR: `Le Sitar, instrument à cordes dans
    la famille de la lute, est très populaire 
    dans la région du nord de l'Inde, au 
    Pakistan et Bangladesh. Mesurant 
    traditionnellement 1,2 mètres (4 pieds) 
    en longueur, le corps du sitar a une 
    forme de poire allongée; un cou long, 
    large et profond; des chevilles 
    tournantes frontales et latérales; et 20 
    frets interchangeable.`,
    descriptionES: `El Sitar, es un instrumento de
    cuerda perteneciente a la familia 
    del Laúd, es popular en India, 
    Pakistán, y Bangladesh. Típicamente 
    mide cerca de 1.2 metros de longitud. 
    El Sitar tiene el cuerpo hondo con 
    forma de calabaza; un largo, ancho y 
    hueco mástil de madera; clavijas en el 
    frente y el costado; y 20 trastes 
    movibles arqueados.`,
    fillColors: Array(396).fill("white"),
  },
  {
    id: "chile",
    nameEN: "Chile",
    nameFR: "Chili",
    nameES: "Chile",
    src: chileImage,
    descriptionEN: `The Araucaria is a Thousand-year-old
    tree that can reach 50 meters high. With its 
    fruits use to provide sustenance to the original 
    peoples of the center-south of Chile. Under its 
    shade the wedding ceremonies are celebrated 
    where they receive the blessing of the mythical 
    tree, which will assure them a happy union. 
    The cultrún is the musical instrument par 
    excellence of the Mapuche shamans and 
    machis. It is a wooden timbale. Each machi or 
    shaman paints it according to a general 
    structure, but with its own design and plays it 
    in its own way. The leather surface is crossed 
    by lines that divide the world into four parts.`,
    descriptionFR: `L'Araucaria est un arbre âgé de mille ans 
    pouvant atteindre 50 mètres de haut. Avec 
    ses fruits, il a nourrit les peuples originaires du 
    centre-sud du Chili. Des cérémonies de 
    mariage ont été célébrées sous son ombre où 
    elles reçoivent la bénédiction de cet arbre 
    mythique, laquelle leur assurera une heureuse 
    union. La cultrún est l'instrument de musique 
    par excellence des chamans et machis 
    mapuches. Il s'agit d'une timbale en bois. 
    Chaque machi ou chaman le peint selon une 
    structure générale, mais avec des détails 
    propres à lui et le joue à sa manière. La 
    surface de cuir de l'instrument est traversée 
    par des lignes qui divisent le monde en quatre 
    parties.`,
    descriptionES: `La araucaria es un árbol milenario que
    puede alcanzar 50 metros de altura. Con sus 
    frutos brindaba el sustento a los pueblos 
    originarios del centro-sur de chile. Bajo su 
    sombra se celebran las ceremonias de bodas 
    donde reciben la bendición del mítico árbol, 
    que les asegurará una feliz unión. El cultrún 
    es el instrumento musical por excelencia de 
    los chamanes mapuches. Se trata de un timbal 
    de madera. Cada machi o chamán lo pinta 
    según una estructura general, pero con un 
    diseño propio y lo toca a su manera. La 
    superficie de cuero está surcada por líneas 
    que dividen el mundo en cuatro partes.`,
    fillColors: Array(188).fill("white"),
  },
  {
    id: "mexico",
    nameEN: "Mexico",
    nameFR: "Mexique",
    nameES: "México",
    src: mexicoImage,
    descriptionEN: `The "charro", in Mexico, is a 
    horse rider; someone who
    practices "charreria", which is 
    considered as the national sport in 
    Mexico. Recently, the "charreria" has 
    gained a high popularity, already as a 
    regulated competitive activity. It finds 
    its authentic manifestation in this 
    country, based on equestrian 
    practices since the colonial times until 
    the Mexican revolution.`,
    descriptionFR: `Le charro, au Mexique, est 
    un cavalier, qui pratique la 
    charrería, qui est considéré comme 
    le sport national au Mexique. 
    Récemment, la charrería est 
    devenue très populaire et est déjà 
    une activité compétitive et 
    réglementée. Il trouve ses origines 
    dans ce pays, basé sur les 
    pratiques et l'équitation de la 
    période de colonisation jusqu'à la 
    révolution mexicaine.`,
    descriptionES: `El charro, en México, es
    un jinete, alguien que practica
    la charrería, considerada como 
    el deporte nacional en México. 
    Recientemente la charrería ha
    tomado un gran auge; y ya es una 
    actividad competitiva y reglamentada. 
    Encuentra su manifestación auténtica 
    en este país, basada en las prácticas 
    ecuestres desde la Colonia hasta la 
    Revolución mexicana.`,
    fillColors: Array(193).fill("white"),
  },
  {
    id: "salvador",
    nameEN: "El Salvador",
    nameFR: "Le Salvador",
    nameES: "El Salvador",
    src: salvadorImage,
    descriptionEN: `The izalqueña costume is worn 
    mostly by older women and 
    middle-aged women; The blouse is 
    made of blanket or poplin and is 
    decorated with contrasting braid or 
    white lace. The outfit is 
    complemented by the colorful 
    shawl woven on cotton loom.`,
    descriptionFR: `Le costume izalqueña est porté 
    principalement par les femmes 
    plus âgées et les femmes d'âge 
    moyen; la blouse est faite de 
    couverture ou de popeline et est 
    décorée de galon contrastant ou 
    de dentelle blanche. La tenue est 
    complétée par le châle coloré tissé 
    sur métier à tisser en coton.`,
    descriptionES: `El traje de izalqueña es utilizado 
    más que todo por las mujeres mas 
    ancianas y las de mediana edad; 
    la blusa está hecha de manta o 
    poplin y se adorna con trencilla de 
    color contrastante o encaje 
    blanco. El atuendo es 
    complementado con el chal de 
    colores tejido en telar con hilo de 
    algodón.`,
    fillColors: Array(79).fill("white"),
  },
  {
    id: "slovenia",
    nameEN: "Slovenia",
    nameFR: "Slovénie",
    nameES: "Eslovenia",
    src: sloveniaImage,
    descriptionEN: `This festive clothing is typical for 
    northwestern Slovenia. Girls wear 
    gold or black embroidery on the 
    forehead. They have a shoulder 
    scarf with a striped and floral 
    pattern and a golden chain with a 
    colorful bow. A male vest has tiny 
    floral patterns and many copper or 
    silver buttons.`,
    descriptionFR: `Ce vêtement de fête est typique du 
    nord-ouest de la Slovénie. Les filles 
    portent des broderies dorées ou 
    noires sur le front. Elles ont un foulard 
    à motif rayé et floral, et une chaîne 
    dorée avec un nœud en couleurs 
    vives. Un gilet pour homme comporte 
    de minuscules motifs floraux et de 
    nombreux boutons en couleur cuivre 
    ou argenté.`,
    descriptionES: `Esta ropa festiva es típica del 
    noroeste de Eslovenia. Las niñas 
    llevan el borde dorado o negro en 
    la frente. Tienen un pañuelo en el 
    hombro con un patrón de rayas y 
    flores y una cadena de oro con un 
    arco de colores. El chaleco 
    masculino tiene pequeños diseños 
    de flores, y muchos botones de 
    cobre o plata.`,
    fillColors: Array(144).fill("white"),
  },
  {
    id: "hungary",
    nameEN: "Hungary",
    nameFR: "Hongrie",
    nameES: "Hungría",
    src: hungaryImage,
    descriptionEN: `The art of Kalocsa embroidery
    originates from the 19th century. 
    The embroidery was originally plain
    white and the pattern was formed of 
    holes. It was only in the 20th century 
    when the Kalocsa embroidery began 
    to use colored materials on a wider 
    scale. Kalocsa embroidery is like a 
    fingerprint: there aren’t two pieces 
    which are the same in pattern and 
    color.`,
    descriptionFR: `L'art de la broderie Kalocsa remonte 
    au XIXe siècle. La broderie était à 
    l'origine d'un blanc uni et le motif était 
    formé de trous. Ce n'est qu'au 20e 
    siècle que la broderie Kalocsa a 
    commencé à utiliser des matériaux 
    colorés à une plus grande échelle. La 
    broderie Kalocsa est comme une 
    empreinte digitale: il n'y a pas deux 
    pièces qui ont le même motif et la 
    même couleur.`,
    descriptionES: `El arte del bordado de Kalocsa se 
    origina en el siglo XIX. Originalmente, 
    el bordado era blanco liso y el dibujo 
    estaba formado por agujeros. Fue 
    recién en el siglo XX cuando el 
    bordado de Kalocsa comenzó a 
    utilizar materiales de color en una 
    escala más amplia. El bordado de 
    Kalocsa es como una huella digital: 
    no hay dos piezas que sean iguales 
    en patrón y color.`,
    fillColors: Array(167).fill("white"),
  },
  {
    id: "israel",
    nameEN: "Israel",
    nameFR: "Israël",
    nameES: "Israel",
    src: israelImage,
    descriptionEN: `Israel is a "Dancing Nation".
    Holy festivals of Israel are called Hagim 
    which means Dancing in a Circle.
    People in Israel mostly dance together in 
    circles. Nobody is first or last in a circle, all 
    are Equal. The number three means 
    many, three dancers are a dancing group.
    The Dove with the Olive Branch is our 
    symbol for Peace since "Noah 
    Ark".Language of Israel is Hebrew, it is 
    written from right to left.`,
    descriptionFR: `Israël est une "nation qui danse". 
    Les festivals sacrés d'Israël sont appelés 
    "Hagim", ce qui signifie "Danser en cercle". 
    La majorité des israéliens dansent en 
    cercle. 
    Personne n'est premier ou dernier dans un 
    cercle, tout le monde est au même rang. Le 
    numéro trois signifie "nombreux", trois 
    danseurs forment un groupe. La colombe 
    avec la branche d'olivier est notre symbole 
    de paix depuis "l'Arche de Noé". La langue 
    officiel d'Israël est l'hébreu, qui s'écrit de 
    droite à gauche.`,
    descriptionES: `Israel es una nación que baila. Las 
    fiestas sagradas de Israel se llaman 
    Hagim, que significa bailar en círculo. La 
    mayoría de los israelitas bailan juntos en 
    círculos. Nadie es el primero o el último 
    en un círculo, todos son iguales. El 
    número tres significa muchos, tres 
    bailarines son un grupo de baile. La 
    paloma con la rama de olivo es nuestro 
    símbolo de paz desde el "Arca de Noé". 
    El lenguaje de Israel es el hebreo, está 
    escrito de derecha a izquierda.`,
    fillColors: Array(48).fill("white"),
  },
  {
    id: "turkey",
    nameEN: "Turkey",
    nameFR: "Turquie",
    nameES: "Turquía",
    src: turkeyImage,
    descriptionEN: `"Hacivat and Karagöz" is a shadow 
    play which is based on a mutual 
    conversation. It is funny for everyone, 
    and it is played on a screen with twodimensional images. When a 
    conversation is over they will bowand 
    start another conversation. "Hacivat 
    and Karagöz" inscribed in 2009 on the 
    Representative List of the Intangible 
    Cultural Heritage of Humanity by 
    UNESCO.`,
    descriptionFR: `Hacivat et Karagöz" est un jeu d'ombres 
    basé sur une conversation mutuelle.
    Ce jeu est drôle pour tout le monde, et il 
    se joue sur un écran avec des images en 
    deux dimensions. Une fois la 
    conversation terminée, les joueurs 
    s'inclinent et entament une autre 
    conversation. 
    „Hacivat et Karagöz" a été inscrit en 2009 
    sur la Liste représentative du patrimoine 
    culturel immatériel de l'humanité par 
    l'UNESCO`,
    descriptionES: `Hacivat y Karagöz" es un juego de 
    sombras que se basa en una 
    conversación mutua. Es divertido para 
    todos, y se juega en una pantalla con 
    imágenes bidimensionales. Cuando 
    termina
    una conversación, iniciarán otra 
    conversación. "Hacivat y Karagöz" fue 
    inscrito en 2009 en la Lista 
    representativa del patrimonio cultural 
    inmaterial de la humanidad por la 
    UNESCO.`,
    fillColors: Array(590).fill("white"),
  },
  {
    id: "argentina",
    nameEN: "Argentina",
    nameFR: "Argentine",
    nameES: "Argentina",
    src: argentinaImage,
    descriptionEN: `Set in the Argentinian countryside
    can be seen with his typical clothing 
    a gaucho (countryman) drinking mate 
    with his countrywoman (mate is the 
    representative infusive drink of the 
    country, it is made with yerba mate 
    leaves and drank with hot water). In 
    the background is visualized an 
    hornero (national bird) in his 
    characteristic nest and a blooming 
    ceibo (national flower).`,
    descriptionFR: `Situé dans la campagne 
    argentine, il est vêtu de vêtements 
    typiques et prend du mate avec la 
    paysanne (maté est l'infusion 
    représentative du pays et est faite 
    avec des feuilles de maté yerba et 
    est pris avec de l'eau chaude). Au 
    fond de la scène se trouve un 
    hornero (oiseau national) dans son 
    nid caractéristique et un ceibo en 
    fleur (fleur nationale).`,
    descriptionES: `Imagen ambientada en el campo 
    argentino, se ve con su vestimenta 
    típica a un gaucho tomando mate 
    con la paisana (el mate es la 
    infusión representativa del país, 
    está hecho con hojas de yerba mate 
    y se toma con agua caliente). En el 
    fondo de la escena se observa a un 
    hornero (Ave nacional) en su 
    característico nido y un ceibo 
    florecido (Flor nacional).`,
    fillColors: Array(92).fill("white"),
  },
  {
    id: "italy",
    nameEN: "Italy",
    nameFR: "Italie",
    nameES: "Italia",
    src: italyImage,
    descriptionEN: `The art of flag throwing dates back 
    to medieval guilds. The flags were 
    adorned with coats of arms that identified 
    their town and were considered a symbol of purity, 
    and as such, it was not allowed to touch the ground.
    During war times the flag throwers bravely led their 
    troops into battle, their flags were used as a 
    strategic means of communicating to military leaders 
    situations on the battlefield and deliver orders to the 
    soldiers through the specific and symbolic 
    movements. The brave flag-bearers protected their 
    flag with their lives. In times of peace, these 
    previous military flag movements took artistic 
    representations famously exhibited during 
    celebration and festivals and wonderful 
    choreographies are accompanied by drums and 
    trumpets music.`,
    descriptionFR: `L'art du lancer de drapeau remonte
    aux guildes médiévales. les drapeaux 
    étaient ornés de blasons qui identifiaient leur
    ville et étaient considérés comme un symbole de 
    pureté. Il n'était pas permis pour ces drapeaux de 
    toucher le sol.
    En temps de guerre, les lanceurs de drapeau 
    conduisaient courageusement les troupes au combat. 
    Les drapeaux étaient utilisés comme moyen stratégique 
    de communication aux chefs militaires sur les situations 
    sur le champ de bataille pour ensuite donner des ordres 
    aux soldats à travers les mouvements spécifiques et 
    symboliques. Les courageux porteurs de drapeaux 
    protègemt leur drapeau avec leur vie. Maintenant que 
    règne la paix, ces précédents mouvements de 
    drapeaux militaires ont pris une représentation 
    artistique populaire lors des célébrations et des 
    festivals. Des chorégraphies merveilleuses 
    accompagnent la musique de tambours et de 
    trompettes.`,
    descriptionES: `El arte de arrojar banderas data del pasado, 
    de los gremios medievales. Las banderas eran 
    adornadas con escudos que identificaban sus 
    respectivas ciudades y eran consideradas un símbolo 
    de pureza, y como tal no era permitido que tocase el 
    suelo. En tiempos de guerra los arrojadores de 
    banderas valientemente lideraban sus tropas a la 
    batalla, sus banderas eran utilizadas como un medio 
    estratégico para comunicar a los líderes militares 
    situaciones en el campo de batalla y emitir órdenes a los 
    soldados a través de los específicos movimientos 
    simbólicos. Los valientes portadores de las banderas las 
    protegían con sus vidas. En tiempos de paz, estos 
    movimientos de bandera previamente militares tomaron 
    una representación artística famosamente exhibida 
    durante celebraciones y festivales, con maravillosas 
    coreografías acompañadas por tambores y trompetas.`,
    fillColors: Array(208).fill("white"),
  },
  {
    id: "france",
    nameEN: "France",
    nameFR: "La France",
    nameES: "Francia",
    src: franceImage,
    descriptionEN: `Accordions are a family of boxshaped musical instruments of 
    the bellows-driven free-reed 
    aerophone type, colloquially 
    referred to as a squeezebox. A 
    person who plays the accordion 
    is called an accordionist. It is 
    used a lot in French traditional 
    music.`,
    descriptionFR: `Les accordéons sont une famille 
    d'instruments de vent en forme de 
    boîtes avec des anches libres et 
    des soufflets dirigés, 
    communément identifié comme 
    une boîte à serrer. Une personne 
    qui joue de l'accordéon s'appelle 
    un accordéoniste. Il est utilisé 
    beaucoup dans la musique 
    traditionnelle français.`,
    descriptionES: `Los acordeones son una familia 
    de instrumentos musicales en 
    forma de caja del tipo de aerófono 
    de lengüeta libre impulsado por 
    fuelles, conocido coloquialmente 
    como un squeezebox (que significa 
    acordeon). Una persona que toca 
    el acordeón se llama acordeonista. 
    Se usa mucho en la música 
    tradicional francesa. `,
    fillColors: Array(75).fill("white"),
  },
  {
    id: "paraguay",
    nameEN: "Paraguay",
    nameFR: "Paraguay",
    nameES: "Paraguay",
    src: paraguayImage,
    descriptionEN: `The traditional drink of 
    Paraguay, composed of yerba 
    mate, herbs and water with a 
    lot of ice. The Tereré is not 
    just a drink, it's an element 
    that unites families and 
    friends in a moment to share 
    with tranquility and joy.`,
    descriptionFR: `La boisson traditionnelle du 
    Paraguay est composée de 
    yerba mate, d'herbes et d'eau 
    avec beaucoup de glaçons. Le 
    Tereré n'est pas seulement une 
    boisson, c'est également un 
    élément qui unit les familles et 
    les amis dans un seul moment 
    à partager dans la tranquilité et 
    la joie.`,
    descriptionES: `Bebida tradicional del 
    Paraguay, hecha a base de 
    yerba mate, hierbas y agua 
    con abundante hielo. El 
    Tereré no es sólo una bebida, 
    sino un elemento que une a 
    las familias y a los amigos en 
    un momento para compartir 
    con tranquilidad y alegría. `,
    fillColors: Array(67).fill("white"),
  },
  {
    id: "costaRica",
    nameEN: "Costa Rica",
    nameFR: "Costa Rica",
    nameES: "Costa Rica",
    src: costaRicaImage,
    descriptionEN: `The typical Tumbril is a symbol of 
    the Costa Rican worker and 
    farmer. It is one of the 
    conveyances used to transport 
    agricultural products such as coffee 
    since the mid-nineteenth century, 
    at the same time it has also been 
    used as transport for people. It is a 
    national symbol, which reflects the 
    work and humility of many Costa 
    Ricans.`,
    descriptionFR: ` Le chariot traditionnel est un 
    symbol costaricain du travailleur et 
    du fermier. Il s'agit d'un moyen de 
    transport utilisé pour transporter 
    les produits de l'agriculture tel que 
    le café, depuis le milieu du dix-neuvième siècle. Il est aussi utilisé 
    pour transporter des personnes. 
    C'est un symbol national qui réflète 
    le travail et l'humilité du peuple 
    costaricain.`,
    descriptionES: `La Carreta típica es símbolo del 
    trabajador y agricultor 
    costarricense. Es uno de los 
    medios de transporte utilizados 
    para trasladar productos agrícolas 
    como el café desde mediados del 
    siglo XIX, a la vez también se ha 
    utilizado como transporte de 
    personas. Es un símbolo nacional, 
    que refleja la labor y humildad de 
    muchos costarricenses.`,
    fillColors: Array(694).fill("white"),
  },
  {
    id: "bolivia",
    nameEN: "Bolivia",
    nameFR: "Bolivie",
    nameES: "Bolivia",
    src: boliviaImage,
    descriptionEN: `It is the mask used by the 
    Devils, (characters in the dance
    of the Bolivian Diablada), the 
    dance represents a fight between 
    good and evil. The diablada is the 
    dance that represents the origin 
    and the main symbol of the Oruro 
    Carnival that was declared by 
    UNESCO: Masterpiece of the Oral 
    and Intangible Heritage of 
    Humanity.`,
    descriptionFR: `Il s'agit du masque utilisé par
    les diablotins, caractères dans la 
    danse bolivienne Diablada. Cette 
    danse représente une bataille 
    entre le bien et le mal. Le Diablada 
    est une danse représentant une 
    origine et est le symbol principal du 
    carnaval d'Oruro qui a été classé 
    par l'UNESCO comme étant un 
    chef d'oeuvre de l'héritage oral et 
    intangible de l'humanité.`,
    descriptionES: `Es la máscara que utilizan los 
    Diablos, (personajes en la danza 
    de la Diablada boliviana), la danza 
    representa una lucha entre el bien 
    y el mal. La diablada es la danza 
    que representa el origen y el 
    principal símbolo del Carnaval de 
    Oruro que fue declarado por la 
    UNESCO como Obra Maestra del 
    Patrimonio Oral e Inmaterial de la 
    Humanidad.`,
    fillColors: Array(143).fill("white"),
  },
  {
    id: "cyprus",
    nameEN: "Cyprus (northern part)",
    nameFR: "Chypre (partie nord)",
    nameES: "Chipre (parte norte)",
    src: cyprusImage,
    descriptionEN: `It is a traditional dining table in 
    Northern Cyprus. It is made in 
    different colors and designs to 
    attract attention. Recently, it has 
    been used as a precious souvenir.`,
    descriptionFR: `Il s'agit d'une table à manger 
    traditionnelle de la Chypre du 
    nord. Elle est faite de différentes 
    couleurs et motifs pour attirer 
    l'attention. Récemment, elle est 
    conservée comme souvenir 
    précieux.`,
    descriptionES: `Mesa de comedor tradicional de 
    Chipre del Norte. Está hecha en 
    diferentes colores y diseños para 
    atraer la atención. Últimamente, 
    ha sido utilizado como un precioso 
    recuerdo. `,
    fillColors: Array(96).fill("white"),
  },
  {
    id: "switzerland",
    nameEN: "Switzerland",
    nameFR: "La Suisse",
    nameES: "Suiza",
    src: switzerlandImage,
    descriptionEN: `The St. Bernard is a breed of
    very large dogs working in the 
    Alps (mountains). He was used to 
    search for people in the mountains. 
    The name of this dog comes from the 
    Great St. Bernard Hospice, a travelers' 
    hospice on the treacherous Great St 
    Bernard Pass in the Alps between 
    Switzerland and Italy. The little wooden 
    box around his neck holds a special drink 
    so when the dog found a person in the 
    cold mountain, they could drink the 
    special drink and get warm.`,
    descriptionFR: `Le St. Bernard est une race de 
    chien très large qui travaille dans les 
    Alpes (montagnes). Le nom de ce chien 
    provient du célèbre hospice St Bernard, un 
    hospice pour les voyageurs du chemin 
    périlleux de St-Bernard dans les Alpes entre 
    la Swiss et l'Italie. La petite boîte autour de 
    son cou a été utilisée pour mettre des 
    boissons spécials pour que lorsque le chien 
    retrouvait une personne dans les 
    montagnes glaciales, la personne pourra 
    boire cette boisson spéciale et se garder au 
    chaud.`,
    descriptionES: ` El San Bernardo es una raza de 
    perros muy grandes que trabajan en 
    las montañas de los Alpes. Solían 
    usarlos para buscar gente en las 
    montañas. El nombre de este perro 
    proviene del hospicio para viajeros Gran 
    San Bernardo, en el traicionero paso 
    alpino Gran San Bernardo entre Suiza e 
    Italia. La pequeña caja de madera 
    alrededor de su cuello era utilizada para 
    poner una bebida especial en ella, así 
    cuando el perro encontraba una persona 
    en la fría montaña este se la podía tomar 
    y entrar en calor.`,
    fillColors: Array(39).fill("white"),
  },
  {
    id: "kyrgyzstan",
    nameEN: "Kyrgyzstan",
    nameFR: "Kirghizistan",
    nameES: "Kirguistán",
    src: kyrgyzstanImage,
    descriptionEN: `Kyrgyz Shyrdak, a distinctively 
    designed wool rug, is an integral part
    of the traditional nomadic lifestyle of 
    Kyrgyzstan. The technique used to 
    make shyrdaks has been perfected 
    over centuries and passed down from 
    generation to generation. A shyrdak is a 
    highly valuable possession for nomadic 
    people; it’s included in dowries for young 
    brides and presented as a gift for 
    important life events and celebrations.`,
    descriptionFR: `Kyrgyz Shyrdak, un tapis de laine
    tissé distinctivement, est une partie 
    intégrale du mode de vie traditionnel 
    nomade du Kyrgystan. Cette technique 
    qui était utilisée pour fabriquer des 
    shyrdaks a été perfectionnée à travers les 
    siècles et a été tranférée de génération à 
    génération. Un shyrdak est une 
    possession de très grande valeur pour les 
    nomades; il est inclus dans la dot des 
    jeunes mariées et présenté comme 
    cadeau durant les événements importants 
    de la vie et célébrations.`,
    descriptionES: `El Shyrdak kirguís, es una alfombra 
    de lana con diseños distintivos. Es
    una parte fundamental del estilo de vida 
    nómada tradicional de Kirguistán. La 
    técnica utilizada para la elaboración del 
    Shyrdak ha sido perfeccionada a través 
    de los siglos y fue transmitida de 
    generación en generación. Un Shyrdak 
    es una posesión altamente valiosa para 
    la gente nómada; está incluido en el dote 
    de las jóvenes novias, también es 
    presentado como un regalo en eventos y 
    celebraciones importantes de la vida.`,
    fillColors: Array(10).fill("white"),
  },
  {
    id: "greece",
    nameEN: "Greece",
    nameFR: "Grèce",
    nameES: "Grecia",
    src: greeceImage,
    descriptionEN: `Tsolias and Amalia,
    are the typical greek traditional
    costumes in continental regions. Tsolias
    (the male) wears the foustanela (skirt),
    shirt, tights, vest, hat and the popular tsarouhia
    (shoes with the black tassel on the edge).
    This clothing was the basic costume of the
    greeks during the revolution for independence
    (1821). Today it is the costume of the Greek
    Presidential Guard. Amalia (the female) is a
    traditional costume for greek women, based
    on the costume that was worn by the queen of
    Greece, Amalia (1836-1862) and all the women
    of the high society and was a mix of many parts
    of costumes from all the Greek territories.
    Is a colorful dress with many jewelry and hat.`,
    descriptionFR: `Tsolias et Amalia,
    sont les costumes traditionnels
    grecs typiques dans les régions
    continentales. Tsolias (l’homme) porte la
    foustanela (jupe), la chemise, les collants, la
    veste, le chapeau et les “tsarouhia” populaire
    (chaussures avec le gland noir sur le bord). Ce
    vêtement a été le costume de base des Grecs lors
    de la révolution pour l'indépendance (1821) et
    aujourd'hui, c'est le costume de la Garde Présidentielle
    Grecque. Amalia (la femme) est un costume
    traditionnel pour les femmes grecques, basé sur le
    costume porté par la reine de Grèce Amalia (1836-
    1862) et toutes les femmes de la haute société et
    était un mélange de plusieurs parties de costumes
    de tous les grecs territoires. C’est une robe coloré
    avec de nombreux bijoux et un chapeau.`,
    descriptionES: ` Tsolias y Amalia, son los
    trajes tradicionales típicos de los
    griegos en las regiones continentales.
    Tsolias (el masculino) viste la fustanela
    (pollera), camisa, medias, chaleco, sombrero y
    el popular tsarohia (zapatos con una borla negra
    en la punta). Esta vestimenta era la indumentaria
    básica de los griegos durante la revolución para
    la independencia (1821) y también es hoy en día
    el traje de la Guardia Presidencial. Amalia (la
    femenina) es el traje tradicional para las mujeres
    griegas, basado en el traje que vestía la reina
    Amalia (1836-1862) de Grecia y todas las mujeres
    de la alta sociedad, fue una mezcla de diferentes
    partes de trajes de todo el territorio griego. Es
    un colorido vestido con muchas joyas y sombrero.`,
    fillColors: Array(70).fill("white"),
  },
  {
    id: "bulgaria",
    nameEN: "Bulgaria",
    nameFR: "Bulgarie",
    nameES: "Bulgaria",
    src: bulgariaImage,
    descriptionEN: `A Martenitsa is a small piece of 
    adornment, made of white and red 
    yarn, usually in the form of two dolls, a 
    male, and a female. Martenitsi are worn 
    from Baba Marta Day (March 1) until the 
    wearer first sees a stork, swallow, or 
    blossoming tree (or until late March). The 
    name of the holiday means "Grandma 
    March" in Bulgarian. The holiday and the 
    wearing of Martenitsi are a Bulgarian 
    tradition related to welcoming the spring, 
    which according to Bulgarian folklore 
    begins in March.`,
    descriptionFR: `Le Martenista est un morceau 
    d'ornement, fait de laine blanche et rouge
    et prend la forme habituellement de deux 
    poupées, un mâle et une femelle. Les 
    Martenitsis sont portés à partir du jour Baba 
    Marta (1er mars) jusqu'à ce que le porteur voit 
    un cygne, une hirondelle ou un arbre qui 
    bourgeonne (ou jusqu'à la fin du mois de 
    mars). Le nom de cette festivité signifie "la 
    marche de la grand-mère" en bulgare et cette 
    tradition ainsi que le porte de Martenista sont 
    associés à la bienvenue du printemps, qui, 
    selon le folklore bulgare, début en Mars.`,
    descriptionES: `La Martenitsa es una pequeña
    pieza de adorno, hecha con hilos blancos 
    y rojos, usualmente en la forma de dos 
    muñecos; uno masculino y otro femenino. 
    La Martenitsa se lleva puesta a partir del día 
    de "Baba Marta" (primero de marzo) hasta que 
    quien la viste ve por primera vez una cigüeña, 
    una golondrina o un árbol brotando (o hasta 
    fines de marzo). El nombre del feriado 
    significa "La Abuela de Marzo” en búlgaro. El 
    feriado y el llevar puesta las martenitsas son 
    tradiciones búlgaras que tienen que ver con la 
    bienvenida a la primavera, el cual comienza 
    en marzo de acuerdo al folklore búlgaro.`,
    fillColors: Array(104).fill("white"),
  },
];

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_IMAGES":
      return payload;
    default:
      return state;
  }
};
